import { type FC } from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../../../shared/utils/translationUtils";
import { ReactComponent as ReplayIcon } from "../../../../assets/images/replay.svg";
import "./style.less";

export interface ResetBtnProps {
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
}

const ResetBtn: FC<ResetBtnProps> = ({
  disabled = false,
  onClick,
  className,
}) => {
  const { t } = useTranslation();

  return (
    <Button
      className={`rd-reset-btn ${className ?? ""}`}
      data-testid="reset-btn"
      disabled={disabled}
      onClick={onClick}
      icon={<ReplayIcon aria-hidden />}
    >
      {formatTranslation(t("newRatesAndDosage.resetBtn.label"))}
    </Button>
  );
};

export default ResetBtn;
